/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AcceptTeamInviteBody,
  AcceptTeamInviteResponse,
  ApiError,
  CreateTeamBody,
  CreateTeamResponse,
  DeclineTeamInviteBody,
  DeclineTeamInviteResponse,
  GetCompetitionTeamResponse,
  GetMyTeamsResponse,
  GetMyTeamsSort,
  GetTeamsResponse,
  GetTeamsSort,
  InviteUniversalTeamMemberBody,
  InviteUniversalTeamMemberResponse,
  JoinTeamByLinkResponse,
  LeaveTeamResponse,
  SortOrder,
  TeamFormationStatus,
  TeamStatus,
  UpdateUniversalTeamBody,
  UpdateUniversalTeamResponse,
} from '../models/index';
import {
    AcceptTeamInviteBodyFromJSON,
    AcceptTeamInviteBodyToJSON,
    AcceptTeamInviteResponseFromJSON,
    AcceptTeamInviteResponseToJSON,
    ApiErrorFromJSON,
    ApiErrorToJSON,
    CreateTeamBodyFromJSON,
    CreateTeamBodyToJSON,
    CreateTeamResponseFromJSON,
    CreateTeamResponseToJSON,
    DeclineTeamInviteBodyFromJSON,
    DeclineTeamInviteBodyToJSON,
    DeclineTeamInviteResponseFromJSON,
    DeclineTeamInviteResponseToJSON,
    GetCompetitionTeamResponseFromJSON,
    GetCompetitionTeamResponseToJSON,
    GetMyTeamsResponseFromJSON,
    GetMyTeamsResponseToJSON,
    GetMyTeamsSortFromJSON,
    GetMyTeamsSortToJSON,
    GetTeamsResponseFromJSON,
    GetTeamsResponseToJSON,
    GetTeamsSortFromJSON,
    GetTeamsSortToJSON,
    InviteUniversalTeamMemberBodyFromJSON,
    InviteUniversalTeamMemberBodyToJSON,
    InviteUniversalTeamMemberResponseFromJSON,
    InviteUniversalTeamMemberResponseToJSON,
    JoinTeamByLinkResponseFromJSON,
    JoinTeamByLinkResponseToJSON,
    LeaveTeamResponseFromJSON,
    LeaveTeamResponseToJSON,
    SortOrderFromJSON,
    SortOrderToJSON,
    TeamFormationStatusFromJSON,
    TeamFormationStatusToJSON,
    TeamStatusFromJSON,
    TeamStatusToJSON,
    UpdateUniversalTeamBodyFromJSON,
    UpdateUniversalTeamBodyToJSON,
    UpdateUniversalTeamResponseFromJSON,
    UpdateUniversalTeamResponseToJSON,
} from '../models/index';

export interface CreateTeamsRequest {
    createTeamBody: CreateTeamBody;
}

export interface CreateTeamsIdInviteRequest {
    id: string;
    inviteUniversalTeamMemberBody: InviteUniversalTeamMemberBody;
}

export interface CreateTeamsIdInviteAcceptRequest {
    id: string;
    acceptTeamInviteBody: AcceptTeamInviteBody;
}

export interface CreateTeamsIdInviteDeclineRequest {
    id: string;
    declineTeamInviteBody: DeclineTeamInviteBody;
}

export interface CreateTeamsIdJoinRequest {
    id: string;
    token: string;
}

export interface CreateTeamsIdLeaveRequest {
    id: string;
}

export interface DeleteTeamsIdRequest {
    id: string;
}

export interface DeleteTeamsIdMembersMemberIdRequest {
    id: string;
    memberId: string;
}

export interface GetMeTeamsRequest {
    sort?: GetMyTeamsSort;
    order?: SortOrder;
    status?: TeamStatus;
    activeOnly?: GetMeTeamsActiveOnlyEnum;
    limit?: number;
    offset?: number;
    numberOfAvailableOffsets?: number;
}

export interface GetTeamsRequest {
    sort?: GetTeamsSort;
    order?: SortOrder;
    status?: TeamFormationStatus;
    captainId?: string;
    limit?: number;
    offset?: number;
    numberOfAvailableOffsets?: number;
}

export interface GetTeamsIdRequest {
    id: string;
}

export interface UpdateTeamsIdRequest {
    id: string;
    updateUniversalTeamBody: UpdateUniversalTeamBody;
}

/**
 * TeamsApi - interface
 * 
 * @export
 * @interface TeamsApiInterface
 */
export interface TeamsApiInterface {
    /**
     * Create a new universal team. The creator becomes the captain. Teams are not tied to any specific competition — they can enter any challenge or leaderboard competition.
     * @summary Create a team
     * @param {CreateTeamBody} createTeamBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamsApiInterface
     */
    createTeamsRaw(requestParameters: CreateTeamsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateTeamResponse>>;

    /**
     * Create a new universal team. The creator becomes the captain. Teams are not tied to any specific competition — they can enter any challenge or leaderboard competition.
     * Create a team
     */
    createTeams(requestParameters: CreateTeamsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateTeamResponse>;

    /**
     * Captain-only. Invite a user by userId or email address. Generates a unique invite code sent via email. The invited user must accept to join.
     * @summary Invite a member to the team
     * @param {string} id 
     * @param {InviteUniversalTeamMemberBody} inviteUniversalTeamMemberBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamsApiInterface
     */
    createTeamsIdInviteRaw(requestParameters: CreateTeamsIdInviteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InviteUniversalTeamMemberResponse>>;

    /**
     * Captain-only. Invite a user by userId or email address. Generates a unique invite code sent via email. The invited user must accept to join.
     * Invite a member to the team
     */
    createTeamsIdInvite(requestParameters: CreateTeamsIdInviteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InviteUniversalTeamMemberResponse>;

    /**
     * Accept a named invitation using the invite code. Adds the authenticated user to the team as a confirmed member.
     * @summary Accept a team invitation
     * @param {string} id 
     * @param {AcceptTeamInviteBody} acceptTeamInviteBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamsApiInterface
     */
    createTeamsIdInviteAcceptRaw(requestParameters: CreateTeamsIdInviteAcceptRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AcceptTeamInviteResponse>>;

    /**
     * Accept a named invitation using the invite code. Adds the authenticated user to the team as a confirmed member.
     * Accept a team invitation
     */
    createTeamsIdInviteAccept(requestParameters: CreateTeamsIdInviteAcceptRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AcceptTeamInviteResponse>;

    /**
     * Decline a named invitation using the invite code.
     * @summary Decline a team invitation
     * @param {string} id 
     * @param {DeclineTeamInviteBody} declineTeamInviteBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamsApiInterface
     */
    createTeamsIdInviteDeclineRaw(requestParameters: CreateTeamsIdInviteDeclineRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeclineTeamInviteResponse>>;

    /**
     * Decline a named invitation using the invite code.
     * Decline a team invitation
     */
    createTeamsIdInviteDecline(requestParameters: CreateTeamsIdInviteDeclineRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeclineTeamInviteResponse>;

    /**
     * Self-service join using the team\'s static invite token. Anyone with the link can join (subject to team capacity).
     * @summary Join a team via public invite link
     * @param {string} id 
     * @param {string} token Static team invite token from the shareable link
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamsApiInterface
     */
    createTeamsIdJoinRaw(requestParameters: CreateTeamsIdJoinRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<JoinTeamByLinkResponse>>;

    /**
     * Self-service join using the team\'s static invite token. Anyone with the link can join (subject to team capacity).
     * Join a team via public invite link
     */
    createTeamsIdJoin(requestParameters: CreateTeamsIdJoinRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<JoinTeamByLinkResponse>;

    /**
     * Leave a team. Captains must be the last member to leave (which disbands the team) or transfer captaincy first.
     * @summary Leave a team
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamsApiInterface
     */
    createTeamsIdLeaveRaw(requestParameters: CreateTeamsIdLeaveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LeaveTeamResponse>>;

    /**
     * Leave a team. Captains must be the last member to leave (which disbands the team) or transfer captaincy first.
     * Leave a team
     */
    createTeamsIdLeave(requestParameters: CreateTeamsIdLeaveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LeaveTeamResponse>;

    /**
     * Captain-only. Permanently disbands the team. Members are not removed from the document but the status is set to DISBANDED.
     * @summary Disband a team
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamsApiInterface
     */
    deleteTeamsIdRaw(requestParameters: DeleteTeamsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Captain-only. Permanently disbands the team. Members are not removed from the document but the status is set to DISBANDED.
     * Disband a team
     */
    deleteTeamsId(requestParameters: DeleteTeamsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Captain-only. Remove a confirmed member from the team roster and cancel any pending invitations for that user.
     * @summary Remove a member from the team
     * @param {string} id 
     * @param {string} memberId The userId of the member to remove
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamsApiInterface
     */
    deleteTeamsIdMembersMemberIdRaw(requestParameters: DeleteTeamsIdMembersMemberIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Captain-only. Remove a confirmed member from the team roster and cancel any pending invitations for that user.
     * Remove a member from the team
     */
    deleteTeamsIdMembersMemberId(requestParameters: DeleteTeamsIdMembersMemberIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Retrieve teams the authenticated user is a member of.
     * @summary Get current user\'s teams
     * @param {GetMyTeamsSort} [sort] 
     * @param {SortOrder} [order] 
     * @param {TeamStatus} [status] 
     * @param {'true' | 'false'} [activeOnly] Filter to only non-disbanded teams
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {number} [numberOfAvailableOffsets] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamsApiInterface
     */
    getMeTeamsRaw(requestParameters: GetMeTeamsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetMyTeamsResponse>>;

    /**
     * Retrieve teams the authenticated user is a member of.
     * Get current user\'s teams
     */
    getMeTeams(requestParameters: GetMeTeamsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetMyTeamsResponse>;

    /**
     * Retrieve teams with optional filtering by status or captain.
     * @summary List teams
     * @param {GetTeamsSort} [sort] 
     * @param {SortOrder} [order] 
     * @param {TeamFormationStatus} [status] 
     * @param {string} [captainId] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {number} [numberOfAvailableOffsets] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamsApiInterface
     */
    getTeamsRaw(requestParameters: GetTeamsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetTeamsResponse>>;

    /**
     * Retrieve teams with optional filtering by status or captain.
     * List teams
     */
    getTeams(requestParameters: GetTeamsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetTeamsResponse>;

    /**
     * Retrieve a single competition team (squad). Public endpoint for viewing team details.
     * @summary Get a competition team by ID
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamsApiInterface
     */
    getTeamsIdRaw(requestParameters: GetTeamsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetCompetitionTeamResponse>>;

    /**
     * Retrieve a single competition team (squad). Public endpoint for viewing team details.
     * Get a competition team by ID
     */
    getTeamsId(requestParameters: GetTeamsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetCompetitionTeamResponse>;

    /**
     * Captain-only. Update the team name or maximum member count.
     * @summary Update team settings
     * @param {string} id 
     * @param {UpdateUniversalTeamBody} updateUniversalTeamBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamsApiInterface
     */
    updateTeamsIdRaw(requestParameters: UpdateTeamsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpdateUniversalTeamResponse>>;

    /**
     * Captain-only. Update the team name or maximum member count.
     * Update team settings
     */
    updateTeamsId(requestParameters: UpdateTeamsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpdateUniversalTeamResponse>;

}

/**
 * 
 */
export class TeamsApi extends runtime.BaseAPI implements TeamsApiInterface {

    /**
     * Create a new universal team. The creator becomes the captain. Teams are not tied to any specific competition — they can enter any challenge or leaderboard competition.
     * Create a team
     */
    async createTeamsRaw(requestParameters: CreateTeamsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateTeamResponse>> {
        if (requestParameters['createTeamBody'] == null) {
            throw new runtime.RequiredError(
                'createTeamBody',
                'Required parameter "createTeamBody" was null or undefined when calling createTeams().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/teams`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateTeamBodyToJSON(requestParameters['createTeamBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateTeamResponseFromJSON(jsonValue));
    }

    /**
     * Create a new universal team. The creator becomes the captain. Teams are not tied to any specific competition — they can enter any challenge or leaderboard competition.
     * Create a team
     */
    async createTeams(requestParameters: CreateTeamsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateTeamResponse> {
        const response = await this.createTeamsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Captain-only. Invite a user by userId or email address. Generates a unique invite code sent via email. The invited user must accept to join.
     * Invite a member to the team
     */
    async createTeamsIdInviteRaw(requestParameters: CreateTeamsIdInviteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InviteUniversalTeamMemberResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling createTeamsIdInvite().'
            );
        }

        if (requestParameters['inviteUniversalTeamMemberBody'] == null) {
            throw new runtime.RequiredError(
                'inviteUniversalTeamMemberBody',
                'Required parameter "inviteUniversalTeamMemberBody" was null or undefined when calling createTeamsIdInvite().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/teams/{id}/invite`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InviteUniversalTeamMemberBodyToJSON(requestParameters['inviteUniversalTeamMemberBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InviteUniversalTeamMemberResponseFromJSON(jsonValue));
    }

    /**
     * Captain-only. Invite a user by userId or email address. Generates a unique invite code sent via email. The invited user must accept to join.
     * Invite a member to the team
     */
    async createTeamsIdInvite(requestParameters: CreateTeamsIdInviteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InviteUniversalTeamMemberResponse> {
        const response = await this.createTeamsIdInviteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Accept a named invitation using the invite code. Adds the authenticated user to the team as a confirmed member.
     * Accept a team invitation
     */
    async createTeamsIdInviteAcceptRaw(requestParameters: CreateTeamsIdInviteAcceptRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AcceptTeamInviteResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling createTeamsIdInviteAccept().'
            );
        }

        if (requestParameters['acceptTeamInviteBody'] == null) {
            throw new runtime.RequiredError(
                'acceptTeamInviteBody',
                'Required parameter "acceptTeamInviteBody" was null or undefined when calling createTeamsIdInviteAccept().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/teams/{id}/invite/accept`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AcceptTeamInviteBodyToJSON(requestParameters['acceptTeamInviteBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AcceptTeamInviteResponseFromJSON(jsonValue));
    }

    /**
     * Accept a named invitation using the invite code. Adds the authenticated user to the team as a confirmed member.
     * Accept a team invitation
     */
    async createTeamsIdInviteAccept(requestParameters: CreateTeamsIdInviteAcceptRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AcceptTeamInviteResponse> {
        const response = await this.createTeamsIdInviteAcceptRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Decline a named invitation using the invite code.
     * Decline a team invitation
     */
    async createTeamsIdInviteDeclineRaw(requestParameters: CreateTeamsIdInviteDeclineRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeclineTeamInviteResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling createTeamsIdInviteDecline().'
            );
        }

        if (requestParameters['declineTeamInviteBody'] == null) {
            throw new runtime.RequiredError(
                'declineTeamInviteBody',
                'Required parameter "declineTeamInviteBody" was null or undefined when calling createTeamsIdInviteDecline().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/teams/{id}/invite/decline`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DeclineTeamInviteBodyToJSON(requestParameters['declineTeamInviteBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeclineTeamInviteResponseFromJSON(jsonValue));
    }

    /**
     * Decline a named invitation using the invite code.
     * Decline a team invitation
     */
    async createTeamsIdInviteDecline(requestParameters: CreateTeamsIdInviteDeclineRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeclineTeamInviteResponse> {
        const response = await this.createTeamsIdInviteDeclineRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Self-service join using the team\'s static invite token. Anyone with the link can join (subject to team capacity).
     * Join a team via public invite link
     */
    async createTeamsIdJoinRaw(requestParameters: CreateTeamsIdJoinRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<JoinTeamByLinkResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling createTeamsIdJoin().'
            );
        }

        if (requestParameters['token'] == null) {
            throw new runtime.RequiredError(
                'token',
                'Required parameter "token" was null or undefined when calling createTeamsIdJoin().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['token'] != null) {
            queryParameters['token'] = requestParameters['token'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/teams/{id}/join`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => JoinTeamByLinkResponseFromJSON(jsonValue));
    }

    /**
     * Self-service join using the team\'s static invite token. Anyone with the link can join (subject to team capacity).
     * Join a team via public invite link
     */
    async createTeamsIdJoin(requestParameters: CreateTeamsIdJoinRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<JoinTeamByLinkResponse> {
        const response = await this.createTeamsIdJoinRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Leave a team. Captains must be the last member to leave (which disbands the team) or transfer captaincy first.
     * Leave a team
     */
    async createTeamsIdLeaveRaw(requestParameters: CreateTeamsIdLeaveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LeaveTeamResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling createTeamsIdLeave().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/teams/{id}/leave`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LeaveTeamResponseFromJSON(jsonValue));
    }

    /**
     * Leave a team. Captains must be the last member to leave (which disbands the team) or transfer captaincy first.
     * Leave a team
     */
    async createTeamsIdLeave(requestParameters: CreateTeamsIdLeaveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LeaveTeamResponse> {
        const response = await this.createTeamsIdLeaveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Captain-only. Permanently disbands the team. Members are not removed from the document but the status is set to DISBANDED.
     * Disband a team
     */
    async deleteTeamsIdRaw(requestParameters: DeleteTeamsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteTeamsId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/teams/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Captain-only. Permanently disbands the team. Members are not removed from the document but the status is set to DISBANDED.
     * Disband a team
     */
    async deleteTeamsId(requestParameters: DeleteTeamsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteTeamsIdRaw(requestParameters, initOverrides);
    }

    /**
     * Captain-only. Remove a confirmed member from the team roster and cancel any pending invitations for that user.
     * Remove a member from the team
     */
    async deleteTeamsIdMembersMemberIdRaw(requestParameters: DeleteTeamsIdMembersMemberIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteTeamsIdMembersMemberId().'
            );
        }

        if (requestParameters['memberId'] == null) {
            throw new runtime.RequiredError(
                'memberId',
                'Required parameter "memberId" was null or undefined when calling deleteTeamsIdMembersMemberId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/teams/{id}/members/{memberId}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));
        urlPath = urlPath.replace(`{${"memberId"}}`, encodeURIComponent(String(requestParameters['memberId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Captain-only. Remove a confirmed member from the team roster and cancel any pending invitations for that user.
     * Remove a member from the team
     */
    async deleteTeamsIdMembersMemberId(requestParameters: DeleteTeamsIdMembersMemberIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteTeamsIdMembersMemberIdRaw(requestParameters, initOverrides);
    }

    /**
     * Retrieve teams the authenticated user is a member of.
     * Get current user\'s teams
     */
    async getMeTeamsRaw(requestParameters: GetMeTeamsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetMyTeamsResponse>> {
        const queryParameters: any = {};

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        if (requestParameters['order'] != null) {
            queryParameters['order'] = requestParameters['order'];
        }

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        if (requestParameters['activeOnly'] != null) {
            queryParameters['activeOnly'] = requestParameters['activeOnly'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['numberOfAvailableOffsets'] != null) {
            queryParameters['numberOfAvailableOffsets'] = requestParameters['numberOfAvailableOffsets'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/me/teams`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetMyTeamsResponseFromJSON(jsonValue));
    }

    /**
     * Retrieve teams the authenticated user is a member of.
     * Get current user\'s teams
     */
    async getMeTeams(requestParameters: GetMeTeamsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetMyTeamsResponse> {
        const response = await this.getMeTeamsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve teams with optional filtering by status or captain.
     * List teams
     */
    async getTeamsRaw(requestParameters: GetTeamsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetTeamsResponse>> {
        const queryParameters: any = {};

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        if (requestParameters['order'] != null) {
            queryParameters['order'] = requestParameters['order'];
        }

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        if (requestParameters['captainId'] != null) {
            queryParameters['captainId'] = requestParameters['captainId'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['numberOfAvailableOffsets'] != null) {
            queryParameters['numberOfAvailableOffsets'] = requestParameters['numberOfAvailableOffsets'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/teams`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetTeamsResponseFromJSON(jsonValue));
    }

    /**
     * Retrieve teams with optional filtering by status or captain.
     * List teams
     */
    async getTeams(requestParameters: GetTeamsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetTeamsResponse> {
        const response = await this.getTeamsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve a single competition team (squad). Public endpoint for viewing team details.
     * Get a competition team by ID
     */
    async getTeamsIdRaw(requestParameters: GetTeamsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetCompetitionTeamResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getTeamsId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/teams/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetCompetitionTeamResponseFromJSON(jsonValue));
    }

    /**
     * Retrieve a single competition team (squad). Public endpoint for viewing team details.
     * Get a competition team by ID
     */
    async getTeamsId(requestParameters: GetTeamsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetCompetitionTeamResponse> {
        const response = await this.getTeamsIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Captain-only. Update the team name or maximum member count.
     * Update team settings
     */
    async updateTeamsIdRaw(requestParameters: UpdateTeamsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpdateUniversalTeamResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateTeamsId().'
            );
        }

        if (requestParameters['updateUniversalTeamBody'] == null) {
            throw new runtime.RequiredError(
                'updateUniversalTeamBody',
                'Required parameter "updateUniversalTeamBody" was null or undefined when calling updateTeamsId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/teams/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateUniversalTeamBodyToJSON(requestParameters['updateUniversalTeamBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpdateUniversalTeamResponseFromJSON(jsonValue));
    }

    /**
     * Captain-only. Update the team name or maximum member count.
     * Update team settings
     */
    async updateTeamsId(requestParameters: UpdateTeamsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpdateUniversalTeamResponse> {
        const response = await this.updateTeamsIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const GetMeTeamsActiveOnlyEnum = {
    True: 'true',
    False: 'false'
} as const;
export type GetMeTeamsActiveOnlyEnum = typeof GetMeTeamsActiveOnlyEnum[keyof typeof GetMeTeamsActiveOnlyEnum];
